import { render, staticRenderFns } from "./userType.vue?vue&type=template&id=9723b65c"
import script from "./userType.vue?vue&type=script&lang=js"
export * from "./userType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports